module.exports = __webpack_public_path__ + "media/images/logo_p5-ffebb56f42efb24a07ed11c2f012aef7.svg";